import { render, staticRenderFns } from "./ReportLiabilityDamage.vue?vue&type=template&id=9d9e0fce&scoped=true&"
import script from "./ReportLiabilityDamage.vue?vue&type=script&lang=ts&"
export * from "./ReportLiabilityDamage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportLiabilityDamage.vue?vue&type=style&index=0&id=9d9e0fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9e0fce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VCardText,VCardTitle,VRadio,VRadioGroup})
